import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from "utils/api/Api";
import BookListItem from "app/books/components/BookListItem";

export const TeacherBooks = ({ teacherName, teacherId }) => {
    const { school } = useParams();

    const { data: teacherBookList, isLoading, isError, error } = useQuery({
        queryKey: ['teacher/books', teacherId],
        queryFn: () => Api.get(`/api/dongwha/teacher/${teacherId}/books`)
    });

    // 없으면 안보여주고
    if (isLoading) return null;
    if (isError) return <div className="no_data">{createFetchErrorMessage(error).message}</div>;
    return (
        <div className="teacher_book_list contents">
            <div className="inner">
                <div className="hdline">
                    <p className="desc">{teacherName} 훈장님의 <span>다양한 작품들</span>을 만나보아요.</p>
                </div>
                {(teacherBookList.data?.length <= 0) && <div className="no_data"><p>훈장님의 작품이 없습니다.</p></div>}
                <ul className="list">
                    {
                        teacherBookList.data?.map((book) => {
                            return (
                                <li key={book.id}>
                                    <Link to={`/${school}/book/${book.book.isbn}`}>
                                        <BookListItem book={book.book} />
                                    </Link>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        </div>
    );
};